import React, { Component } from 'react'

export default class StepFreeForm extends Component {

  constructor(props) {
    super(props);

    this.updateResult = this.props.updateResult;

    this.state = { answerValue: this.props.initialResult };
    this.handleAnswerChange = this.handleAnswerChange.bind(this);
  }

  handleAnswerChange(event) {
    const {
      isOptional,
      itemDestinationName
    } = this.props.options;
    
    const { answerValue } = this.state;
    let answers = answerValue ? answerValue : {};
    answers[itemDestinationName] = event.target.value;

    this.setState({ answerValue: answers });
    this.updateResult(
      event.target.value !== '' || isOptional,
      itemDestinationName,
      event.target.value
    );
  }

  componentDidUpdate() {
    const {
      canGoToNextStep
    } = this.props;
    const {itemDestinationName} = this.props.options;

    if (!canGoToNextStep && (this.state.answerValue && this.state.answerValue[itemDestinationName] != '')) {
      this.updateResult(
        true
      );
    }
  }

  handleLabelClick = () => {
    this.inputElement.focus();
  }

  render() {
    const {
      itemLabel,
      answerFieldLabel,
      errorMessage,
      isOptional,
      itemDestinationName
    } = this.props.options;
    const {
      textMaximumLength,
      viewErrors
    } = this.props;
    const { answerValue } = this.state;

    const currentAnswer = answerValue && answerValue[itemDestinationName] ? answerValue[itemDestinationName] : "";

    const isFilled = currentAnswer && currentAnswer.length > 0;

    return (
      <div className="tab">
        <div className="question">{itemLabel}</div>
        <div className={`form-field quiz-textarea auto-mt-xs ${isFilled ? 'is-filled' : 'is-empty'}`} >
          <textarea
            ref={input => this.inputElement = input}
            className={`form-field__input  ${!isOptional && viewErrors && currentAnswer === '' ? 'is-error__border' : ""}`}
            value={currentAnswer}
            onChange={this.handleAnswerChange}
            rows="4"
            maxLength={textMaximumLength}
          />
          <label
            className="form-field__label"
            htmlFor=""
            onClick={this.handleLabelClick}
          >
            {answerFieldLabel}
          </label>
          {!isOptional && viewErrors && currentAnswer === '' ? <ul className="form-field__error-list filled">
            <li className="form-field__error-item">{errorMessage}</li>
          </ul> : null}
        </div>
      </div>
    )
  }
}
